// External Link Constants
import {
  THRONE_URL,
  APPLE_PAY_EMAIL,
  LOYALFANS_URL,
  TRYST_URL,
  TWITTER_URL,
  INSTAGRAM_URL,
  TIKTOK_URL,
  MSHA_URL,
  CompanyEmailAddress,
} from '../../utils/Constants';

// Icons
import {
  FaTwitter,
  FaInstagram,
  FaApple,
  FaTiktok,
  FaGift,
  FaLink,
} from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { SiOnlyfans } from 'react-icons/si';
import { GiStoneThrone } from 'react-icons/gi';
import { RiScales3Fill } from 'react-icons/ri';
import { MdOutlineEmail } from 'react-icons/md';

// ============================
// Fansites / Booking
// ============================
export const fanButtonArray = [
  {
    text: 'LoyalFans – Premium Content',
    link: LOYALFANS_URL,
    icon: <FaGift />,
  },
  {
    text: 'Tryst – Profile & Rates',
    link: TRYST_URL,
    icon: <RiScales3Fill />,
  },
];

// ============================
// Social
// ============================
export const socialLinkButtonArray = [
  { text: 'Twitter / X', link: TWITTER_URL, icon: <FaXTwitter /> },
  { text: 'Instagram', link: INSTAGRAM_URL, icon: <FaInstagram /> },
  { text: 'TikTok', link: TIKTOK_URL, icon: <FaTiktok /> },
  {
    text: 'Email',
    link: `mailto:${CompanyEmailAddress}`,
    icon: <MdOutlineEmail />,
  },
];

// ============================
// Payments & Tributes
// ============================
export const payLinkButtonArray = [
  { text: 'Throne – Cash Gifts', link: THRONE_URL, icon: <GiStoneThrone /> },
  {
    text: 'Apple Pay (via Email)',
    link: `mailto:${APPLE_PAY_EMAIL}`,
    icon: <FaApple />,
  },
];

// ============================
// Full Link Hub (msha.ke)
// ============================
export const linkHubButtonArray = [
  {
    text: 'All My Links – msha.ke',
    link: MSHA_URL,
    icon: <FaLink />,
  },
];

// Small social pins used in other components
export const smallSocialMediaPins = [
  {
    serviceName: 'X',
    icon: <FaXTwitter />,
    url: TWITTER_URL,
    background: { background: '#1DA1F2' },
  },
  {
    serviceName: 'Instagram',
    icon: <FaInstagram />,
    url: INSTAGRAM_URL,
    background: { background: '#C13584' },
  },
  {
    serviceName: 'Email',
    icon: <MdOutlineEmail />,
    url: `mailto:${CompanyEmailAddress}`,
    background: { background: '#FFFC00' },
  },
  {
    serviceName: 'Throne',
    icon: <GiStoneThrone />,
    url: THRONE_URL,
    background: { background: '#25D366' },
  },
];
